export default function(size) {
  return `(min-width: ${size}px)`;
};